import { TranslationAPI } from '@lumapps/translations';

import { LegacyNotification } from '../types';

export const getEventTitle = (translation: TranslationAPI, notification?: LegacyNotification): string => {
    if (notification?.properties?.event_title) {
        return translation.translateObject(notification.properties.event_title) || '';
    }

    return '';
};
